<template>
  <div id="mention-page">
    <page-header-component
      v-if="topics"
      @filterChange="filterChange"
      :topics="topics"
      :hideValidate="false"
      :hideCakupan="false"
      icon="bi bi-chat-left-text"
      title="Mentions"
    />
    <div class="row">
      <div :class="is_mobile ? 'col-md-12 px-gap' : 'col-md-9 px-gap'">
        <div
          class="widget-12 card card-default widget-loader-circle no-margin shade h-100"
        >
          <div class="card-body p-t-0">
            <div class="row m-b-10">
              <div class="col-md-6 col-sm-6">
                <div class="pull-left m-t-5 m-b-5">
                  <h5 class="m-b-0">Daftar Mentions</h5>
                  <p class="small hint-text">
                    <span v-if="data_from && data_to"
                      >Detail Mentions Per
                      {{ this.data_from | date_time_to_indo }} Hingga
                      {{ this.data_to | date_time_to_indo }}</span
                    >
                    <span v-else>Detail Mentions 7 hari terakhir</span>
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="p-t-25" align="right">
                  <button
                    id="link-button"
                    aria-label=""
                    class="btn btn-success btn-icon-left m-b-10"
                    type="button"
                    href="#"
                    tabindex="0"
                    title="Ekspor Data Saat Ini Kedalam File Excel"
                  >
                    <i class="bi bi-filetype-xlsx mr-1"></i> Ekspor Data
                  </button>
                  <b-popover target="link-button" triggers="focus">
                    <div
                      class="clickable hoverable"
                      title="Berdasarkan Tanggal Publikasi Pada Sumber Terkait"
                      @click="ekspor('date')"
                    >
                      Tanggal Publikasi
                    </div>
                    <div
                      class="clickable hoverable mt-2"
                      title="Berdasarkan Tanggal Berita Tersimpan Kedalam Sistem"
                      @click="ekspor('input_date')"
                    >
                      Tanggal Tersimpan
                    </div>
                  </b-popover>
                </div>
              </div>
            </div>
            <div class="row m-t-15">
              <div class="col-md-12">
                <div id="post-el">
                  <floating-loader-component
                    text="Sedang memuat data"
                    v-if="isLoading"
                  />
                  <div
                    v-if="isError && !isLoading"
                    class="alert alert-danger"
                    id="errorApiEl"
                    role="alert"
                    align="center"
                  >
                    <strong>API Error! </strong> {{ resp.status }}
                    {{ resp.statusText }}
                    <br />
                    Mohon maaf atas ketidak nyamanannya. Silahkan hubungi
                    administrator. <br />
                    <router-link to="/posts">
                      <i class="bi bi-arrow-repeat" /> Muat ulang
                    </router-link>
                  </div>
                  <post-list-component
                    v-if="posts && !isError"
                    :posts="posts"
                    :pers="pers"
                    :topics="topics"
                    :highlights="highlight_list"
                    :keyword="topic_keyword"
                    style="width: 100%"
                    class="m-b-10"
                    string_limit="230"
                    :key="post_key"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!is_mobile" class="col-md-3 px-gap">
        <div
          class="widget-12 card card-default widget-loader-circle no-margin post-filter-sidebar shade h-100"
        >
          <div class="card-body p-t-0">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <filter-channel-component
                  v-if="display_tipe == 3 && tipe != 2"
                  :key="channel_key"
                  param_name="channel"
                  collapse="true"
                  id="filter-channel"
                  :totalMedsos="totalMedsos"
                  :totalMedkon="totalMedkon"
                  :is_loading="is_source_loading"
                />
                <filter-source-sentiment-component
                  :key="sources_key"
                  param_name="sources"
                  title="Filter Source"
                  sub-title="Filter data berdasarkan source"
                  :lists="sources"
                  collapse="true"
                  :is_loading="is_source_loading"
                  id="filter-source"
                />
                <filter-source-sentiment-component
                  :key="sentiments_key"
                  param_name="sentiments"
                  title="Filter Sentimen"
                  sub-title="Filter data berdasarkan sentimen"
                  :lists="sentiments"
                  :is_loading="is_sentiment_loading"
                  collapse="true"
                  id="filter-sentiment"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="is_mobile" class="overlay-button">
        <button
          @click="showFilterMobile"
          title="Filter Data"
          class="btn btn-success"
        >
          <i class="bi bi-funnel-fill"></i>
        </button>
      </div>
      <floating-loader-component
        :key="float_loading_key"
        v-if="is_float_loading"
        :text="float_loading_text"
      />
      <modal-dynamic-component
        v-if="show_filter_mobile"
        :key="filter_mobile_key"
        modal_id="filter_mobile"
        :modal="filter_mobile"
      />
      <v-tour
        v-if="tour_steps.length > 0"
        name="myTour"
        :steps="tour_steps"
        :options="{ highlight: true }"
      />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import "bootstrap";
import page_header from "@/views/components/page_header.vue";
import filter_source_sentiment from "@/views/components/mention/filter_source_sentiment.vue";
import post_list from "@/views/components/mention/post_list.vue";
import "select2";
import gp from "@/plugins/generalPlugins.js";
import floating_loader from "@/views/components/floating_loader.vue";
import moment from "moment";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;
import { isMobile } from "mobile-device-detect";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modalFilterMobile from "@/views/components/mention/modal_filter_mobile.vue";
import { getTopicKeyword } from "@/models/topic.js";
import filter_channel from "../components/mention/filter_channel.vue";

export default {
  name: "Mention",
  title: "Mentions | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "filter-source-sentiment-component": filter_source_sentiment,
    "post-list-component": post_list,
    "floating-loader-component": floating_loader,
    "modal-dynamic-component": modal_dynamic,
    "filter-channel-component": filter_channel,
  },
  data() {
    return {
      sources: null,
      sentiments: null,
      posts: null,
      isLoading: true,
      isError: false,
      resp: null,
      pers: null,
      topics: null,
      data_from: this.$route.query.from,
      data_to: this.$route.query.to,
      query: null,
      sources_key: 0,
      sentiments_key: 10,
      post_key: 20,
      float_loading_key: 30,
      filter_mobile_key: 40,
      is_float_loading: false,
      float_loading_text: "",
      is_mobile: isMobile,
      show_filter_mobile: false,
      filter_mobile: {},
      id_project: this.$store.getters.user.id_project,
      display_tipe: this.$store.getters.user.project.project_detail
        .display_tipe,
      tipe: this.$store.getters.user.project.project_detail.tipe,
      tour_steps: [],
      highlight_list: [],
      topic_keyword: [],
      channel_key: 50,
      channels: [],
      totalMedsos: 0,
      totalMedkon: 0,
      activeChannel: null,
      is_source_loading: true,
      is_sentiment_loading: true,
      stats_load_count: 0,
      sentiment_stats_load_count: 0,
    };
  },
  methods: {
    getData: function() {
      var self = this;
      var params = this.$route.query;

      if ("tier" in params) {
        if (params.tier > 0) {
          params.pers = 1;
        }
      }

      if ("q" in params) {
        params.q = btoa(params.q);
      }
      self.$route.query;

      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if ("q" in params) {
        params.q = atob(params.q);
      }

      if (query != "") {
        this.query = query;
        let api;
        if (this.$store.getters.user.project.project_detail.tipe == 1) {
          api =
            process.env.VUE_APP_API_URL +
            "posts-dev/" +
            this.id_project +
            "?" +
            query;
        } else {
          api =
            process.env.VUE_APP_API_URL +
            "posts-classic/" +
            this.id_project +
            "?" +
            query;
        }

        this.$http
          .get(api)
          .then(function(response) {
            if (response.status == 204) {
              self.posts = {};
              $("#btn-export").addClass("disabled");
              $("#btn-export").addClass("btn-info");
              $("#btn-export").removeClass("btn-success");
              $("#btn-export").prop("disabled", true);
            } else {
              $("#btn-export").removeClass("disabled");
              $("#btn-export").removeClass("btn-info");
              $("#btn-export").addClass("btn-success");
              $("#btn-export").prop("disabled", false);
              self.posts = response.data;
            }
          })
          .catch(function(err) {
            self.resp = err.response;
            self.isError = true;
          })
          .finally(function() {
            self.isLoading = false;
            self.post_key++;
          });
      }
    },
    getPers: function() {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "pers";
      this.$http
        .get(api)
        .then(function(response) {
          if (response.status == 204) {
            self.pers = [];
          } else {
            self.pers = response.data;
          }
        })
        .catch(function(err) {
          console.log(err);
          self.pers = [];
        });
    },
    getTopic: function() {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function(response) {
          if (response.status == 204) {
            self.topics = {};
          } else {
            self.topics = response.data;
          }
        })
        .catch(function() {
          self.topics = {};
        })
        .finally(() => {
          this.getData();
          this.getFiltersData();
          this.getFiltersSentiment();
        });
    },
    getFiltersData: function() {
      var self = this;
      if (self.stats_load_count == 0) {
        self.is_source_loading = true;
      }
      var params = this.$route.query;
      if (!params.from) {
        params.from = this.$store.getter.filter_date_from;
        params.to = this.$store.getter.filter_date_to;
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        query = {
          from: params.from,
          to: params.to,
        };
        if ("q" in params) {
          query.q = btoa(params.q);
        }
        if ("topic_selected" in params) {
          query.topic_selected = params.topic_selected;
        }
        if ("cakupan" in params) {
          query.cakupan = params.cakupan;
        }
        if ("group" in params) {
          query.group = params.group;
        }
        if ("highlight" in params) {
          query.highlight = params.highlight;
        }
        if ("pers" in params) {
          query.pers = params.pers;
        }
        if ("tier" in params) {
          query.tier = params.tier;
        }
        if ("is_validated" in params) {
          query.is_validated = params.is_validated;
        }
        if ("day" in params) {
          query.day = params.day;
        }

        query = Object.keys(query)
          .map((key) => key + "=" + query[key])
          .join("&");
        let api =
          process.env.VUE_APP_API_URL +
          "stats-source/" +
          this.id_project +
          "?" +
          query;
        // if (this.$store.getters.user.project.project_detail.tipe == 1) {
        //   api =
        //     process.env.VUE_APP_API_URL +
        //     "stats/" +
        //     this.id_project +
        //     "?" +
        //     query;
        // } else {
        //   api =
        //     process.env.VUE_APP_API_URL +
        //     "stats-classic/" +
        //     this.id_project +
        //     "?" +
        //     query;
        // }

        this.$http
          .get(api)
          .then(function(response) {
            if (response.status == 204) {
              let tmp = false;
              self.assembleSources(tmp);
              self.assembleChannelFilter(tmp);
            } else {
              self.assembleSources(response.data);
              self.assembleChannelFilter(response.data);
            }
          })
          .catch(function() {
            self.sources = [];
            self.sentiments = [];
          })
          .finally(() => {
            self.stats_load_count += 1;
            self.is_source_loading = false;
          });
      }
    },
    assembleSources: function(stats) {
      var sources = [];
      if (this.display_tipe == 3) {
        sources = [
          {
            id: "sources-all",
            code: "sources-all",
            icon: "bi bi-layout-text-sidebar",
            name: "Semua",
            count: stats ? stats.total : 0,
          },
        ];
        if (this.activeChannel.twitter.status == 1) {
          sources.push({
            id: "twitter",
            code: "twitter",
            icon: "bi bi-twitter",
            name: "Twitter",
            count: stats ? stats.twitter : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.facebook.status == 1) {
          sources.push({
            id: "facebook",
            code: "facebook",
            icon: "bi bi-facebook",
            name: "Facebook",
            count: stats ? stats.facebook : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.instagram.status == 1) {
          sources.push({
            id: "instagram",
            code: "instagram",
            icon: "bi bi-instagram",
            name: "Instagram",
            count: stats ? stats.instagram : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.tiktok.status == 1) {
          sources.push({
            id: "tiktok",
            code: "tiktok",
            icon: "bi bi-tiktok",
            name: "Tiktok",
            count: stats ? ("tiktok" in stats ? stats.tiktok : 0) : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.youtube.status == 1) {
          sources.push({
            id: "youtube",
            code: "youtube",
            icon: "bi bi-youtube",
            name: "Youtube",
            count: stats ? stats.youtube : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.linkedin.status == 1) {
          sources.push({
            id: "linkedin",
            code: "linkedin",
            icon: "bi bi-linkedin",
            name: "Linkedin",
            count: stats ? (stats.linkedin ? stats.linkedin : 0) : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.google.forum_status == 1) {
          sources.push({
            id: "forum",
            code: "forum",
            icon: "bi bi-chat-dots-fill",
            name: "Forum",
            count: stats ? stats.forum : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.google.blog_status == 1) {
          sources.push({
            id: "blog",
            code: "blog",
            icon: "bi bi-rss",
            name: "Blog",
            count: stats ? stats.blog : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if ("review" in this.activeChannel) {
          if (this.activeChannel.review.status == 1) {
            sources.push({
              id: "review",
              code: "review",
              icon: "bi bi-phone",
              name: "Review Aplikasi",
              count: stats.review ? stats.review : 0,
              disable: this.display_tipe == 2 ? true : false,
            });
          }
        }

        if (this.activeChannel.google.news_status == 1) {
          sources.push({
            id: "news",
            code: "news",
            icon: "bi bi-globe-americas",
            name: "Online News",
            count: stats ? stats.news : 0,
            disable: this.display_tipe == 1 ? true : false,
          });
        }
      } else if (this.display_tipe == 1) {
        sources = [
          {
            id: "sources-all",
            code: "sources-all",
            icon: "bi bi-layout-text-sidebar",
            name: "Semua",
            count: stats ? stats.total : 0,
          },
        ];
        if (this.activeChannel.twitter.status == 1) {
          sources.push({
            id: "twitter",
            code: "twitter",
            icon: "bi bi-twitter",
            name: "Twitter",
            count: stats ? stats.twitter : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.facebook.status == 1) {
          sources.push({
            id: "facebook",
            code: "facebook",
            icon: "bi bi-facebook",
            name: "Facebook",
            count: stats ? stats.facebook : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.instagram.status == 1) {
          sources.push({
            id: "instagram",
            code: "instagram",
            icon: "bi bi-instagram",
            name: "Instagram",
            count: stats ? stats.instagram : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.tiktok.status == 1) {
          sources.push({
            id: "tiktok",
            code: "tiktok",
            icon: "bi bi-tiktok",
            name: "Tiktok",
            count: stats ? ("tiktok" in stats ? stats.tiktok : 0) : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.youtube.status == 1) {
          sources.push({
            id: "youtube",
            code: "youtube",
            icon: "bi bi-youtube",
            name: "Youtube",
            count: stats ? stats.youtube : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.linkedin.status == 1) {
          sources.push({
            id: "linkedin",
            code: "linkedin",
            icon: "bi bi-linkedin",
            name: "Linkedin",
            count: stats ? (stats.linkedin ? stats.linkedin : 0) : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.google.forum_status == 1) {
          sources.push({
            id: "forum",
            code: "forum",
            icon: "bi bi-chat-dots-fill",
            name: "Forum",
            count: stats ? stats.forum : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if (this.activeChannel.google.blog_status == 1) {
          sources.push({
            id: "blog",
            code: "blog",
            icon: "bi bi-rss",
            name: "Blog",
            count: stats ? stats.blog : 0,
            disable: this.display_tipe == 2 ? true : false,
          });
        }
        if ("review" in this.activeChannel) {
          if (this.activeChannel.review.status == 1) {
            sources.push({
              id: "review",
              code: "review",
              icon: "bi bi-phone",
              name: "Review Aplikasi",
              count: stats.review ? stats.review : 0,
              disable: this.display_tipe == 2 ? true : false,
            });
          }
        }
      } else if (this.display_tipe == 2) {
        sources = [
          {
            id: "sources-all",
            code: "sources-all",
            icon: "bi bi-layout-text-sidebar",
            name: "Semua",
            count: stats ? stats.total : 0,
          },
        ];
        if (this.activeChannel.google.news_status == 1) {
          sources.push({
            id: "news",
            code: "news",
            icon: "bi bi-globe-americas",
            name: "Online News",
            count: stats ? stats.news : 0,
            disable: this.display_tipe == 1 ? true : false,
          });
        }
      }

      if (this.$store.getters.user.project.project_detail.tipe == 1) {
        if (this.display_tipe != 1) {
          if (this.activeChannel.formed.tv_status == 1) {
            sources.push({
              id: "media_tv",
              code: "media_tv",
              icon: "bi bi-tv",
              name: "Media TV",
              count: stats ? stats.media_tv : 0,
              disable: this.display_tipe == 1 ? true : false,
            });
          }
          if (this.activeChannel.formed.cetak_status == 1) {
            sources.push({
              id: "media_cetak",
              code: "media_cetak",
              icon: "bi bi-newspaper",
              name: "Media Cetak",
              count: stats ? stats.media_cetak : 0,
              disable: this.display_tipe == 1 ? true : false,
            });
          }
        }
      } else if (
        this.$store.getters.user.project.project_detail.tipe == 2 &&
        this.display_tipe == 1
      ) {
        if (this.activeChannel.google.news_status == 1) {
          sources.push({
            id: "news",
            code: "news",
            icon: "bi bi-globe-americas",
            name: "Online News",
            count: stats ? stats.news : 0,
            disable: false,
          });
        }
      }

      this.sources = sources;
      this.sources_key++;
    },
    getFiltersSentiment: function() {
      if (this.sentiment_stats_load_count == 0) {
        this.is_sentiment_loading = true;
      }
      var params = this.$route.query;
      if (!params.from) {
        params.from = this.$store.getter.filter_date_from;
        params.to = this.$store.getter.filter_date_to;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        query = {
          from: params.from,
          to: params.to,
        };
        if ("q" in params) {
          query.q = btoa(params.q);
        }
        if ("topic_selected" in params) {
          query.topic_selected = params.topic_selected;
        }
        if ("cakupan" in params) {
          query.cakupan = params.cakupan;
        }
        if ("group" in params) {
          query.group = params.group;
        }
        if ("highlight" in params) {
          query.highlight = params.highlight;
        }
        if ("pers" in params) {
          query.pers = params.pers;
        }
        if ("is_validated" in params) {
          query.is_validated = params.is_validated;
        }
        if ("day" in params) {
          query.day = params.day;
        }

        query = Object.keys(query)
          .map((key) => key + "=" + query[key])
          .join("&");
        let api =
          process.env.VUE_APP_API_URL +
          "stats-sentiment/" +
          this.id_project +
          "?" +
          query;
        // if (this.$store.getters.user.project.project_detail.tipe == 1) {
        //   api =
        //     process.env.VUE_APP_API_URL +
        //     "stats-sentiment/" +
        //     this.id_project +
        //     "?" +
        //     query;
        // } else {
        //   api =
        //     process.env.VUE_APP_API_URL +
        //     "stats-classic/" +
        //     this.id_project +
        //     "?" +
        //     query;
        // }

        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.assembleSentimenFilter(response.data);
            } else {
              this.assembleSentimenFilter(false);
            }
          })
          .catch(function(err) {
            console.log(err);
            self.sentiments = [];
          })
          .finally(() => {
            this.sentiment_stats_load_count += 1;
            this.is_sentiment_loading = false;
          });
      }
    },
    assembleSentimenFilter: function(stats) {
      var sentimen = [
        {
          id: "sentimen-all",
          icon: "bi bi-layout-text-sidebar",
          name: "Semua",
          count: stats ? stats.positif + stats.netral + stats.negatif : 0,
        },
        {
          id: 1,
          code: "positif",
          icon: "bi bi-emoji-smile",
          name: "Positif",
          count: stats ? stats.positif : 0,
        },
        {
          id: 0,
          code: "netral",
          icon: "bi bi-emoji-neutral",
          name: "Netral",
          count: stats ? stats.netral : 0,
        },
        {
          id: -1,
          code: "negatif",
          icon: "bi bi-emoji-frown",
          name: "Negatif",
          count: stats ? stats.negatif : 0,
        },
      ];

      this.sentiments = sentimen;
      this.sentiments_key++;
    },
    assembleChannelFilter: function(stats) {
      this.totalMedsos = stats ? stats.total_medsos : 0;
      this.totalMedkon = stats ? stats.total_medkon : 0;
      this.channel_key++;
    },
    ekspor: function(type) {
      let api = process.env.VUE_APP_API_URL;
      let api_project = api + "project-detail/" + this.id_project;
      // let nama_proyek;
      // let nama_file;
      this.$http.get(api_project).then((response) => {
        if (response.status == 200) {
          let fulldate = moment().format("YYYYMMDHHmmss");
          // nama_proyek = response.data.project_detail.name;
          // nama_file =
          //   "MediaMonitoring-" + nama_proyek + "-" + fulldate + ".xlsx";
          var params = this.$route.query;

          if ("page" in params) {
            delete params.page;
          }

          if ("q" in params) {
            params.q = btoa(params.q);
          }

          params.time = fulldate;
          params.date_type = type;
          params.sort = type;

          let query = Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&");
          let url_api =
            process.env.VUE_APP_API_URL +
            "new-export/" +
            this.id_project +
            "?" +
            query;
          window.open(url_api);
          // const link = document.createElement("a");
          // link.href = url_api;
          // link.target = "_blank";
          // link.setAttribute("download", nama_file);
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
        }
      });
    },
    eksporClipping: function() {
      this.float_loading_text = "Mengekspor data...";
      this.is_float_loading = true;
      this.float_loading_key++;
      let nama_file = "kliping.pdf";
      var params = this.$route.query;

      if ("page" in params) {
        delete params.page;
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL +
        "printClips/" +
        this.id_project +
        "?" +
        query;

      this.$http({
        url: api,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          if (res.status == 200) {
            this.float_loading_text = "Berhasil Mengekspor data...";
            this.is_float_loading = true;
            this.float_loading_key++;

            var fileURL = window.URL.createObjectURL(new Blob([res.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", nama_file);
            document.body.appendChild(fileLink);
            fileLink.click();
          } else if (res.status == 204) {
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> Data kosong, tidak dapat mengekspor data!',
                position: "top",
                timeout: 5000,
                type: "warning",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_float_loading = false;
        });
    },
    showFilterMobile: function() {
      this.filter_mobile = {
        title: "Filter Data",
        subtitle: "",
        component: modalFilterMobile,
      };
      this.filter_mobile_key++;
      this.show_filter_mobile = true;
    },
    filterChange: function() {
      var params = this.$route.query;
      if ("day" in params) {
        delete params.day;
        let current_path = this.$route.path;
        this.$router
          .replace(current_path)
          .then(this.$router.replace({ query: params }));
      }
      if ("hash" in this.$route) {
        if (this.$route.hash != "") {
          params.q = this.$route.hash.replace("#", "");
          params.page = 1;
          this.$router.replace({ query: params });
        }
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query) {
        this.isLoading = true;
        this.data_from = this.$route.query.from;
        this.data_to = this.$route.query.to;
        this.getTopic();
      }
    },
    getHighlight: function() {
      let api =
        process.env.VUE_APP_API_URL + "highlight-ids/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.highlight_list = response.data;
          }
        })
        .catch(() => {
          this.highlight_list = [];
        });
    },
    getChannel: function() {
      let api =
        process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
      axios({ url: api, data: {}, method: "GET" }).then((response) => {
        this.activeChannel = response.data.project_detail.crawler;
      });
    },
  },
  filters: {
    date_time_to_indo: function(tanggal) {
      return gp.dateTimeID(tanggal);
    },
  },
  watch: {
    $route: {
      immediate: false,
      handler() {
        var params = this.$route.query;
        if (
          "page" in params ||
          "q" in params ||
          "sort" in params ||
          "items" in params ||
          "excludes" in params ||
          "account" in params ||
          "cakupan" in params ||
          "tier" in params ||
          "pers" in params
        ) {
          if ("hash" in this.$route) {
            if (this.$route.hash != "") {
              params.q = this.$route.hash.replace("#", "");
              params.page = 1;
              this.$router.replace({ query: params });
            }
          }
          let query = Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&");

          if (this.query != query) {
            this.isLoading = true;
            this.getData();
            this.getFiltersData();
            this.getFiltersSentiment();
            this.data_from = this.$route.query.from;
            this.data_to = this.$route.query.to;
          }
        } else {
          let query = Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&");
          if (this.query != query) {
            this.isLoading = true;
            this.getData();
            this.getFiltersData();
            this.getFiltersSentiment();
            this.data_from = this.$route.query.from;
            this.data_to = this.$route.query.to;
          }
        }
      },
    },
  },
  created: async function() {
    this.topic_keyword = await getTopicKeyword(
      this.$store.getters.user.id_project
    );
    this.getPers();
    this.getHighlight();
    this.getTopic();
    this.getChannel();
  },
  mounted: function() {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("body").offset().top,
      },
      1000
    );
    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#btn-export",
      header: {
        title: "Export Data",
      },
      content:
        "Gunakan tombol ini untuk mengekspor data dalam periode terkait kedalam file excel.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#post-sort",
      header: {
        title: "Pengurutan Data",
      },
      content:
        "Anda dapat mengurutkan data berdasarkan engagement, popularitas dan posting terbaru.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#post-per-page",
      header: {
        title: "Data per Halaman",
      },
      content:
        "Anda dapat menyesuaikan tampilan data per halaman dengan memilih pilihan pada dropdown ini.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#post-pers-filter",
      header: {
        title: "Filter Jenis Akun",
      },
      content:
        "Anda dapat memfilter jenis akun yang akan ditampilkan antara lain pers, non pers, atau keduanya.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#post-tier-filter",
      header: {
        title: "Filter Tier",
      },
      content:
        "Akun dengan jenis pers dikelompokan menjadi beberapa tier. Gunakan dropdown ini untuk memfilter postingan dari akun pers yang memiliki tier.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#post-search-form",
      header: {
        title: "Cari Data",
      },
      content:
        "Masukan kata kunci untuk mencari data. Kata kunci akan digunakan untuk mencari data berdasarkan nama akun dan konten.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#post-tandai-semua",
      header: {
        title: "Tandai Semua",
      },
      content:
        "Tandai semua postingan yang ditampilkan. Setelah ditandai Anda dapat mengubah sentimen semua posting yand ditandai, mencetak kliping, dan membagikannya ke sosial media.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#post-highlight",
      header: {
        title: "Tampilkan Post yang Dihighlight",
      },
      content:
        "Anda dapat menampilkan postingan hanya yang ditandai saja menggunakan checkbox ini.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#post-pagination",
      header: {
        title: "Pagination",
      },
      content:
        "Anda dapat berpindah-pindah halaman menggunakan tombol paging ini.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[12] = {
      target: "#filter-channel",
      header: {
        title: "Filter Channel",
      },
      content:
        "Digunakan untuk memfilter data yang akan ditampilkan berdasarkan jenis media.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[13] = {
      target: "#filter-source",
      header: {
        title: "Filter Source",
      },
      content:
        "Digunakan untuk memfilter data yang akan ditampilkan berdasarkan sumber.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[14] = {
      target: "#filter-sentiment",
      header: {
        title: "Filter Sentimen",
      },
      content:
        "Digunakan untuk memfilter data yang akan ditampilkan berdasarkan sentimen.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[15] = {
      target: ".account-name",
      header: {
        title: "Nama Akun atau Judul Postingan",
      },
      content:
        "Jika postingan berasal dari sosial media maka akan menampilkan nama akun, jika berasal dari media konvensional akan menampilkan judul berita",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[16] = {
      target: ".post-meta",
      header: {
        title: "Statistik Posting",
      },
      content:
        "Menampilkan statistik postingan seperti like, share, retweet, dan lain-lain tergantung dari sumber mana postingan berasal. Anda dapat mengarahkan cursor ke icon untuk melihat label setiap statistik. Klik sentimen atau icon emotion untuk mengganti sentimen dan emostion.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[17] = {
      target: ".post-text-content",
      header: {
        title: "Konten Posting",
      },
      content: "Konten dari sebuah postingan.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[18] = {
      target: ".post-action-button-wrap",
      header: {
        title: "Tombol Aksi Postingan",
      },
      content:
        "Tombol Lihat Detail digunakan untuk melihat detail dari postingan yang dipilih. Tombol Highlight digunakan untuk menghighlight atau menandai sebuah postingan yang nantinya jika ada postingan serupa sistem akan otomatis menandai postingan tersebut. Kunjungi/Lihat sumber untuk melihat post asli. Selain itu Anda dapat menghapus postingan dengan menekan tombol hapus. Post yang dihapus akan pindah ke halaman trash bin.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.select2-container {
  z-index: 1 !important;
}
.container {
  padding-left: 5px !important;
  padding-right: 5px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  width: 100% !important;
  max-width: 100% !important;
}
.overlay-button {
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 9;
}
.overlay-button button {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  font-size: 30px;
  font-weight: bolder;
}
</style>
